import { render, staticRenderFns } from "./Metatags.vue?vue&type=template&id=19275562"
import script from "./Metatags.vue?vue&type=script&lang=js"
export * from "./Metatags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports